import { forwardRef, useEffect, useState } from "react";
import { UseFormReturn } from "react-hook-form";
import { toast } from "sonner";

import footerImg from "@/assets/images/footerImg.png";
import headerDefault from "@/assets/images/headerImg.png";

import watermarkImg from "/fav.png";

import { WasteFormat } from "@/interfaces/wastetype.interface";
import { cn } from "@/lib/utils";
import { TReportSetting } from "@/schemas/waste-settings.schema";
import { toDataUrl } from "@/utils/helpers";

interface FormatToPrintProps {
  form: UseFormReturn<TReportSetting>;
  data: WasteFormat | undefined;
}

const FormatToPrint = forwardRef<HTMLDivElement, FormatToPrintProps>(
  ({ form, data }, ref) => {
    const [firstImg, setFirstImg] = useState<unknown>();
    const [secondImg, setSecondImg] = useState<unknown>();
    const [thirdImg, setThirdImg] = useState<unknown>();

    useEffect(() => {
      const getImages = async (): Promise<void> => {
        if (data?.headerImage) {
          if (data?.headerImage === null) {
            return;
          }
          const img1 = await toDataUrl(data?.headerImage);
          setFirstImg(img1);
        } else {
          setFirstImg(headerDefault);
        }
        if (data?.watermarkImage) {
          if (data?.watermarkImage === null) {
            return;
          }
          const img2 = await toDataUrl(data?.watermarkImage);
          setSecondImg(img2);
        } else {
          setSecondImg(watermarkImg);
        }
        if (data?.footerImage) {
          if (data?.footerImage === null) {
            return;
          }

          const img2 = await toDataUrl(data?.footerImage);
          setThirdImg(img2);
        } else {
          setThirdImg(footerImg);
        }
      };

      getImages().catch((err) => {
        toast.error(err.message);
      });
    }, [data, form]);

    return (
      <div
        id='formatToPrint'
        ref={ref}
        className={cn(
          "flex flex-col justify-between border rounded-sm aspect-[1/1.414]",
          ref === null && "h-full",
          "print:w-full print:h-full print:m-0 print:p-0",
        )}
      >
        <div className='w-full'>
          {form.watch("headerActive") && (
            <img
              src={
                form.watch("headerImage")?.preview || firstImg || headerDefault
              }
              alt='formatLogo'
              className={cn(
                `w-full object-fill`,
                ref === null ? "h-20" : "h-[125px]",
              )}
              style={{ opacity: form.watch("headerOpacity") }}
            />
          )}
        </div>
        {form.watch("watermarkActive") && (
          <div className='m-auto'>
            <img
              src={
                form.watch("watermarkImage")?.preview ||
                secondImg ||
                watermarkImg
              }
              alt='form watermark'
              className='w-[150px] h-[150px] object-contain'
              style={{
                opacity: form.watch("watermarkOpacity"),
                transform: `scale(${form.watch("watermarkScale")})`,
              }}
            />
          </div>
        )}
        {form.watch("footerActive") && (
          <div className='w-full place-self-end'>
            <img
              src={form.watch("footerImage")?.preview || thirdImg || footerImg}
              alt='footer'
              className={cn(
                `w-full object-fill`,
                ref === null ? "h-20" : "h-[125px]",
              )}
              style={{ opacity: form.watch("footerOpacity") }}
            />
          </div>
        )}
      </div>
    );
  },
);

FormatToPrint.displayName = "FormatToPrint";
export default FormatToPrint;
